import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { boolean, object, string } from 'yup';
import { ModeFormValues } from 'src/models/Mode.model';
import ModeForm from '../Layouts/ModeForm';
import { useAddModeMutation } from 'src/services/ModeServices';
import { showToast } from 'src/utils/showToaster';
type Props = {
  onClose: () => void;
};

const AddModeFormWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: ModeFormValues = {
    modeName: '',
    modeDescription: '',
    isVirtual: false,
  };

  // Validation Schema
  const validationSchema = object().shape({
    modeName: string().required('Please enter name'),
    modeDescription: string().required('Please enter description'),
    isVirtual: boolean().required('Required'),
  });

  const [addMode] = useAddModeMutation()

  // Handle Submit
  const handleSubmit = (
    values: ModeFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ModeFormValues>
  ) => {
    addMode(values).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <ModeForm formType='ADD' formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddModeFormWrapper;